import { InjectionToken, ProviderToken } from '@angular/core';
import { FormTemplateInterface } from '../interfaces/form-template.interface';
import { DefaultFormValue } from '../interfaces/default-form-value.interface';


export const FormServicesInjectionToken: InjectionToken<
  Map<string, ProviderToken<FormTemplateInterface<DefaultFormValue>>>
> = new InjectionToken('formServices');
